var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDisease03Off(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3346 12.2165C29.3346 7.6772 25.8527 4 21.5562 4C19.3772 4 17.413 4.94859 16.0013 6.47193C14.5896 4.94859 12.6226 4 10.4464 4C6.14987 4 2.66797 7.67999 2.66797 12.2165C2.66797 13.5808 2.98882 14.867 3.54402 15.9997H3.53844C3.53844 15.9997 5.78717 21.4067 15.9985 28.3817C26.2126 21.4067 28.4586 15.9997 28.4586 15.9997H28.453C29.011 14.867 29.3291 13.5808 29.3291 12.2165H29.3346Z",
    fill: "#B4B8BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72656 15.2007H11.5427L13.9742 10.4648L17.9943 19.96L20.5529 15.2007H23.272",
    stroke: "#E2E6EC",
    strokeWidth: 1.67228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDisease03Off);
export default __webpack_public_path__ + "static/media/i_disease_03_off.a509369fb7d3dfa3167db1dedb1d44f5.svg";
export { ForwardRef as ReactComponent };